export default function getChangeColor (value) {
  if (value > 0) return '#60d180'
  if (value < 0) return '#eb595a'
  return 'gray'
}
